import React, {useCallback} from 'react';
import {ChooseDropdown, DropdownSelectTrigger, Flex} from '@priority-software/priority-style-react';
import {
    DropdownItemData,
    SupportedValue
} from '@priority-software/priority-style-react/dist/components/DropdownV2/ChooseDropdown/ChooseDropdown';
import {StatusIcon} from './StatusIcon';

type Props = {
    options: DropdownItemData[];
    value: SupportedValue;
    onChange: (option: DropdownItemData, name: string) => void;
    name: string;
    portalSelector?: string;
    placeholder?: string;
};

type AdditionalOptionData = {
    color?: string;
};

export const StatusDropdown = (props: Props) => {
    const {options, name, onChange, value, portalSelector, placeholder} = props;
    const selectedOptionRef = React.useRef(options.find(option => option.value === value) || null);

    const onSelect = useCallback(
        (option: DropdownItemData) => {
            onChange(option, name);
            selectedOptionRef.current = option;
        },
        [name, onChange]
    );

    const itemContentRenderer = useCallback(
        item => (
            <Flex justifyContent="flex-start">
                <StatusIcon color={(item.data as AdditionalOptionData)?.color} hasMargin />{' '}
                {item.label}
            </Flex>
        ),
        []
    );

    return (
        <ChooseDropdown
            trigger={
                <DropdownSelectTrigger
                    beforeValue={
                        value ? (
                            <StatusIcon
                                color={
                                    (selectedOptionRef.current?.data as AdditionalOptionData)?.color
                                }
                            />
                        ) : null
                    }
                    placeholder={placeholder}
                    value={value !== 0 ? (value as string) : undefined}
                />
            }
            onChange={onSelect}
            value={value}
            data={options}
            itemContentRenderer={itemContentRenderer}
            name={name}
            portalSelector={portalSelector}
            usePortal
        />
    );
};
